import {
  Component,
  Input,
  ElementRef,
  forwardRef,
  Renderer,
  Inject,
  ViewEncapsulation
} from '@angular/core';
import { MdlMenuComponent } from './mdl-menu.component';
import { BooleanProperty } from '../common/boolean-property';



export class MdlMenuItemComponent {

   @BooleanProperty() public disabled: boolean;

  public element: HTMLElement;
  // forwardRef is needed because of he circular dependency menu queries menuitems; menuitem needs the parent
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer,
     private mdlMenu: MdlMenuComponent) {
    this.element = elementRef.nativeElement;
  }

  public onClick($event) {
    $event.stopPropagation();
    if (this.disabled) {
      this.mdlMenu.hide();
      return;
    }
    this.mdlMenu.hideOnItemClicked();
  }

  // we need to register a touchstart at the window to get informed if the user taps outside the menu.
  // But if we register a touchstart event - safari will no longer convert touch events to click events.
  // So we need to convert touch to click and the user still needs to register a (click) listener to be
  // informed if the menu item has clicked.
  public onTouch($event) {
    // ensure that this event is totally consumed
    $event.stopPropagation();
    $event.preventDefault();

    let event = new MouseEvent('click', {bubbles: true});
    this.renderer.invokeElementMethod(this.element, 'dispatchEvent', [event]);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-menu-item',
  host: {
    '[class.mdl-menu__item]': 'true',
    'tabindex': '-1',
    '(click)': 'onClick($event)',
    '(touchstart)': 'onTouch($event)'
  },
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
{type: MdlMenuComponent, decorators: [{ type: Inject, args: [forwardRef(() => MdlMenuComponent), ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'disabled': [{ type: Input, args: ['disabled', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
